export default __webpack_public_path__ + "static/pink-klarna-dc65a4c768e548ad3c0d4a27c3486ac0.svg";